import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FieldRule } from '../../channels.model';

@Component({
  selector: 'app-channel-field-rules-tab',
  standalone: false,
  templateUrl: './channel-field-rules-tab.component.html',
  styleUrl: './channel-field-rules-tab.component.scss'
})
export class ChannelFieldRulesTabComponent {
  @Input() fieldRules: FieldRule[] = [];
  @Output() fieldRulesChange = new EventEmitter<FieldRule[]>();

  showOptionalFields = false;
  showAddRuleForm = false;
  newRule: { fieldName: string; priority: FieldRule['priority']; conditionalLogic: string; alwaysRequired: boolean } = {
    fieldName: '', priority: 'P1', conditionalLogic: '', alwaysRequired: false
  };
  newRuleError = false;

  get enabledFieldRuleCount(): number {
    return this.fieldRules.filter(r => r.enabled).length;
  }

  toggleFieldRule(rule: FieldRule): void {
    this.fieldRulesChange.emit(
      this.fieldRules.map(r => r.id === rule.id ? { ...r, enabled: !r.enabled } : r)
    );
  }

  openAddRuleForm(): void {
    this.showAddRuleForm = true;
    this.newRule = { fieldName: '', priority: 'P1', conditionalLogic: '', alwaysRequired: false };
    this.newRuleError = false;
  }

  addFieldRule(): void {
    this.newRuleError = !this.newRule.fieldName.trim();
    if (this.newRuleError) return;
    this.fieldRulesChange.emit([...this.fieldRules, {
      id: `fr-${Date.now()}`,
      fieldName: this.newRule.fieldName.trim(),
      alwaysRequired: this.newRule.alwaysRequired,
      conditionalLogic: this.newRule.conditionalLogic.trim() || undefined,
      priority: this.newRule.priority,
      enabled: true
    }]);
    this.showAddRuleForm = false;
  }

  removeFieldRule(id: string): void {
    this.fieldRulesChange.emit(this.fieldRules.filter(r => r.id !== id));
  }
}
